import { ReactElement } from 'react'
import { toast, TypeOptions } from 'react-toastify'

const notificationToast = (icon: ReactElement, type: TypeOptions, message: string, className?: string, autoClose = 6000): ReturnType<typeof toast> => (
  toast(
    <div
      className='flex items-center' style={{ display: 'flex', alignItems: 'center' }}
    >
      {icon}
      <div className='pa6' style={{ padding: '1rem', fontSize: '1rem' }}>
        {message}
      </div>
    </div>, {
      autoClose,
      position: toast.POSITION.TOP_RIGHT,
      closeButton: true,
      type,
      ...(className !== undefined && { className })
    })
)

export default notificationToast
